import React from 'react';
import { LinkedInButton } from '../../../components/fields/buttons/socialButtons/LinkedInButton';
import qs from 'qs';
import { APP_ROUTES } from '../../../routing/AppRoutes';

function handleLoginBtnClick() {
  const clientId = process.env.REACT_APP_LINKEDIN_OAUTH_CLIENT_ID;
  const urlQs = qs.stringify({
    client_id: clientId,
    redirect_uri: `${window.location.origin}${APP_ROUTES.LINKEDIN_CALLBACK}`,
    response_type: 'code',
    scope: 'r_emailaddress r_liteprofile w_member_social',
  });
  window.location.href = `https://www.linkedin.com/oauth/v2/authorization?${urlQs}`;
}

export const LinkedInButtonContainer: React.FC<any> = (props) => {
  return <LinkedInButton onClick={handleLoginBtnClick} {...props} />;
};
